var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import emitter from 'element-ui/src/mixins/emitter';
export default Vue.extend({
    mixins: [emitter],
    computed: __assign({}, mapState('vinsurance', ['cityList'])),
    props: {
        value: Number,
        disabled: {
            type: Boolean,
            default: false,
        },
        changeOnSelect: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: true,
        },
    },
    data: function () {
        return {
            // cityList: [],
            options: [],
        };
    },
    methods: {
        getCityList: function () {
            if (!this.cityList ||
                !Array.isArray(this.cityList) ||
                this.cityList.length === 0) {
                this.$store.dispatch('vinsurance/GET_CITY_LIST');
            }
        },
        // handleBlur () {
        //   this.dispatch('ElFormItem', 'el.form.blur')
        // },
        changeOptions: function () {
            if (this.value > 100) {
                this.options = [Math.floor(this.value / 100), this.value];
            }
            else {
                this.options = [this.value, this.value];
            }
        },
    },
    watch: {
        value: function () {
            this.changeOptions();
        },
        options: function (val) {
            this.$emit('input', val[1]);
            this.$emit('change', val);
        },
    },
    created: function () {
        this.getCityList();
        this.changeOptions();
    },
});
